// English resources for the public landing page (namespace "landing").
// Keep keys in sync with ../pl/landing.ts.
//
// 2026-09-19: Domi restored the earlier three-edit composition.
//
// 2026-09-20, round 37-R3 (the public page as a road to action): an eyebrow names the
// audience above the headline.
//
// 2026-09-23, package HD: the owner chose hero D ("D is the best", 22.09), so the A / B call
// is closed: `hero.title`, `hero.titleA` and `hero.lead` are gone. The second picture ("One
// series. All your accounts.") went with `accountsMap.*`.
//
// 2026-09-27, package H47: the owner chose hero 47-A ("fanbase parabola" + "FAN EDIT
// GENERATOR"), so the hero D keys (`eyebrow`, `titleD`, `leadD`, `how`, `map.today`,
// `map.days`, `mapAlt`) and the three-step section `how.*` are gone: part 2 of the hero
// carries the owner's three steps.
//
// The credibility pass (P06) still applies: every number on the page is true and comes
// from `/api/billing/plans` (`gem_costs.render`, `gem_costs.publish`, the Starter price)
// or from `lib/startBonus.ts`, i.e. from the catalogue in `app/billing/costs.py`. One
// footer, one set of keys: `footer.*` serves the landing, pricing, FAQ, legal pages and
// the guest 404.
export const landing = {
  nav: {
    funkcje: 'Features',
    jak: 'How it works',
    cennik: 'Pricing',
    faq: 'FAQ',
    toPanel: 'Go to edits',
    login: 'Sign in',
    startFree: 'Start free',
  },
  hero: {
    // Hero 47-A (package H47, 27.09): the owner's words (MAPA 47-A §6), capitals included.
    // Part 1 "fanbase parabola": the H1 and the line under it (English quotes “…”).
    fanbaseTitle: "Build your own fanbase and change today's Trends",
    fanbaseSub: "Don't wait for a miracle, make that “viral” yourself",
    // Part 2: the H2 in two masked lines ("\n" = the break) and the three steps.
    generatorTitle: 'FAN EDIT\nGENERATOR',
    step1: 'Upload a track',
    step2: 'Generate loads of unique edits',
    step3: 'Post to your own account network!',
    ctaStart: 'Start free',
    ctaPricing: 'See pricing',
    // {n} = the signup bonus divided by the price of an edit (lib/startBonus.ts,
    // read from app/). The unit is interpolated so the count can govern the noun.
    micro: 'No card · {n} free {edits}',
    // Words inside the picture; packs, accounts and frames are data (`lib/landingParabola.data.ts`).
    map: {
      track: 'Night Drive',
      // {n} = the number of edits in a sample pack, unit inflected (`editWord`).
      series: '{n} {edits}',
    },
    // Each picture is ONE image for a screen reader, with this description (MAPA 47-A §6).
    parabolaAlt: 'One track feeds packs of edits along both arms of the parabola, and each pack lights up a new arc of TikTok, Instagram and YouTube accounts.',
    generatorAlt: 'The track goes into the generator, a grid of unique edits comes out, and the edits land on six accounts.',
  },
  showcase: {
    title: 'Sample edits',
    playExample: 'Play sample edit {n}',
    ownClips: 'Your clips',
    packs: 'Clip packs',
    hooks: 'Opening hook',
    variants: 'Different styles',
    error: 'This sample could not be played. Choose another edit.',
    retry: 'Try again',
    // Edit caption and track title on the three-phone mock-up (decoration, `aria-hidden`).
    // The centre one is the same song as `hero.map.track`. Account handles are proper names.
    examples: {
      left: { lyric: 'one more time', track: 'Stop in the Fog' },
      center: { lyric: 'night drive', track: 'Night Drive' },
      right: { lyric: 'stay a while', track: 'Green Crossing' },
    },
  },
  price: {
    heading: 'What it costs',
    // Rule 8: the two-sentence paragraph about paying is down to ONE fact.
    refund: 'A failed render costs nothing.',
    // The money line: the cheapest plan in the `/api/billing/plans` catalogue, the
    // same one Pricing counts from. Without an answer the line is not drawn.
    from: 'Plans from {price} / mo.',
    oneEdit: '1 edit',
    onePublish: '1 post',
    link: 'See plans and prices in Pricing',
  },
  // The closing section: the same dark stage as the first screen, one action and a row
  // of facts, every one of which can be checked on this same page.
  closing: {
    heading: 'Your first series is free.',
    fact1: 'No card to start',
    fact2: 'Only your account sees your files',
    fact3: "You connect accounts with the platform's official login",
    fact4: 'Payments are handled by Stripe',
    fact5: 'Cancel anytime',
  },
  footer: {
    // Three groups (R3): Product / Help / Legal, on EVERY public page. The tagline,
    // the "Account" column and the copyright bar are gone.
    groupProduct: 'Product',
    groupHelp: 'Help',
    groupLegal: 'Legal',
    product: 'Product',
    funkcje: 'Features',
    jak: 'How it works',
    cennik: 'Pricing',
    faq: 'FAQ',
    login: 'Sign in',
    contact: 'Contact',
    terms: 'Terms',
    refunds: 'Refunds & cancellation',
    // The one-line paczka 37 footer used a shorter label; the "Help" group has room
    // for the document's full name.
    refundsShort: 'Refunds',
    // The short label for the legal strip under the sign-in and sign-up card (04a–06d):
    // it stands next to "Terms" and "Report content", where the full name breaks the row.
    privacyShort: 'Privacy',
    // The full name of the document: in a "Legal" group, "Privacy" does not name the
    // file a person signs up under.
    privacyFull: 'Privacy Policy',
    seller: 'JDG Dominik Łupicki',
    report: 'Report content',
    copyright: '© 2026 EDIMI · edimi.ai',
    version: 'Publishing through the official TikTok, Instagram and YouTube APIs',
  },
}
